module.exports = __webpack_public_path__ + "img/one_kid.735a741d.svg";